<template>
<svg :width="width" :height="height" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="skipass">
        <path id="Vector" d="M14.6881 2.98291L14.6881 16.2928" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
        <path id="Vector_2"
            d="M10.4801 31.1957L28.808 22.4368C30.1693 21.7867 30.9099 20.2907 30.6006 18.8137L30.224 17.0127"
            :stroke="color" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
        <path id="Vector_3"
            d="M10.1049 5.83405C10.1049 6.78656 9.33276 7.55872 8.38025 7.55872C7.42774 7.55872 6.65558 6.78656 6.65558 5.83405C6.65558 4.88154 7.42774 4.10938 8.38025 4.10938C9.33276 4.10938 10.1049 4.88154 10.1049 5.83405Z"
            :fill="color" stroke="color" stroke-width="2" />
        <path id="Vector_4"
            d="M21.0292 15.7134L21.0425 15.7224C21.0539 15.735 21.072 15.757 21.0951 15.7918C21.144 15.8652 21.1968 15.9681 21.2454 16.0957C21.3468 16.3616 21.3929 16.6358 21.3929 16.7982L21.3929 24.0443C21.3929 24.4956 21.0285 24.8601 20.5772 24.8601C20.1266 24.8601 19.7614 24.4943 19.7614 24.0443L19.7614 19.8132L19.7614 18.3692L18.4097 18.8771L13.1181 20.8654L13.1055 20.8701L13.0931 20.8752C13.0327 20.8997 12.9796 20.9143 12.931 20.9224L12.8495 20.9359L12.7714 20.9627C12.5661 21.033 12.3599 21.0666 12.1612 21.0666C11.4593 21.0666 10.7852 20.6803 10.4473 20.0193L8.25243 14.8701L8.24121 14.8438L8.2285 14.8182C7.75635 13.8656 8.14509 12.7128 9.09791 12.2406L9.09843 12.2403C10.0486 11.7687 11.2031 12.1571 11.6755 13.11C11.6755 13.11 11.6755 13.11 11.6755 13.11L13.6785 17.1517L14.08 17.962L14.9265 17.6437L20.2412 15.6449L20.2533 15.6403L20.2654 15.6354C20.518 15.5329 20.8053 15.5629 21.0292 15.7134Z"
            :fill="color" stroke="color" stroke-width="2" />
        <path id="Vector_5"
            d="M4.87714 15.1318L7.65441 21.3113C8.67906 23.5899 11.328 24.6461 13.6382 23.6951L14.686 23.2638"
            :stroke="color" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
    </g>
</svg>
</template>

<script>
export default {
    name: "SkipassSVG",
    props: {
        color: {
            type: String,
            default: 'black'
        },
        width: {
            type: String,
            default: '34'
        },
        height: {
            type: String,
            default: '20'
        }
    },
}
</script>

